import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="V" transform="translate(11.000000, 5.000000)">
        <path
          d="M53.1,26.78c0,0.18-0.06,0.36-0.12,0.6l-14.1,38.7c-0.3,0.84-0.96,1.32-1.86,1.32l-4.02,0c-1.14,0-1.68-0.48-2.04-1.5l-14.76-38.34c-0.12-0.24-0.18-0.48-0.18-0.72c0-0.6,0.48-0.96,1.2-0.96l5.28,0c1.26,0,1.86,0.42,2.16,1.26l10.62,29.64l0.18,0l10.02-29.46c0.36-1.08,0.9-1.44,2.28-1.44l4.2,0c0.78,0,1.14,0.36,1.14,0.9z"
          fill="currentColor"
          transform="translate(3.000000, 0.00000)"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
